import React, { useEffect } from 'react';
import styles from './PaypalInfo.module.scss';

/* Translations */
import { useTranslation } from 'react-i18next';
import { tr } from '../../../../../utils/translations/translator';
import { useLoadingContext } from '../../../__providers__/LoadingProvider';

interface PaypalInfoProps {}

export const PaypalInfo: React.FC<PaypalInfoProps> = () => {
  const { t } = useTranslation();
  const { setLoading } = useLoadingContext();

  useEffect(() => {
    setLoading(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.container}>
      <span className={styles.text}>{tr(t, 'paypal-btn-info')}</span>
    </div>
  );
};
